<div class="modal-header">
  <h5 class="modal-title">Configurar {{ tipo }}</h5>
</div>

<div class="modal-body">
  <div class="accordion" id="accordionTipos">
    <div class="accordion-item" *ngFor="let grupo of grupos; trackBy: trackById">
      <h2 class="accordion-header">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
          [attr.data-bs-target]="'#tipo-' + grupo.key">
          <div class="w-100 d-flex align-items-center">
            <!-- TEXTO -->
            <span>{{ grupo.key }}</span>
            <!-- BADGE -->
            <span class="badge bg-primary ms-auto me-2">
              {{ countSelecionados(grupo.value) }} selecionado(s)
            </span>
          </div>
        </button>
      </h2>
      <div [id]="'tipo-' + grupo.key" class="accordion-collapse collapse" data-bs-parent="#accordionTipos">
        <div class="accordion-body">
          <div class="border rounded p-2 mb-2" *ngFor="let item of grupo.value; trackBy: trackById">
            <div class="row g-2 align-items-center">
              <!-- CHECK + NOME -->
              <div class="col-12 col-md-3 d-flex align-items-center">
                <input type="checkbox" class="me-2" [formControl]="getSelecionado(item.index)">
                <strong>{{ item.ctrl.value.nome }}</strong>
              </div>

              <!-- ORDEM -->
              <div class="col-6 col-md-2">
                <label class="form-label mb-0">Ordem</label>
                <input type="number" class="form-control form-control-sm" [formControl]="getOrdem(item.index)">
              </div>

              <!-- SERIES -->
              <div class="col-6 col-md-2" *ngIf="tipo !== 'cardio'">
                <label class="form-label mb-0">Séries</label>
                <input type="number" class="form-control form-control-sm" [formControl]="getSeries(item.index)">
              </div>

              <!-- REPETIÇÕES -->
              <div class="col-6 col-md-2" *ngIf="tipo !== 'cardio'">
                <label class="form-label mb-0">Repetições</label>
                <input type="number" class="form-control form-control-sm" [formControl]="getRepeticoes(item.index)">
              </div>

              <!-- CARGA -->
              <div class="col-6 col-md-2" *ngIf="tipo === 'exercicio'">
                <label class="form-label mb-0">Carga</label>
                <input type="number" class="form-control form-control-sm" [formControl]="getCarga(item.index)">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer p-2">
  <div class="row w-100 g-2">
    <div class="col-6">
      <button class="btn btn-outline-secondary w-100" (click)="activeModal.dismiss()">
        Cancelar
      </button>
    </div>
    <div class="col-6">
      <button class="btn btn-outline-primary w-100" (click)="submit()">
        Salvar
      </button>
    </div>
  </div>
</div>